import { create } from 'zustand'

// We don't mirror receipt data into the store — matrix-js-sdk already tracks it
// on the Room object. We only keep a per-room version counter that bumps on each
// receipt, so subscribed components re-read the live Room and recompute.
interface ReceiptState {
  versions: Map<string, number>
  bump: (roomId: string) => void
}

export const useReceiptStore = create<ReceiptState>((set) => ({
  versions: new Map(),
  bump: (roomId) =>
    set((state) => {
      const versions = new Map(state.versions)
      versions.set(roomId, (versions.get(roomId) ?? 0) + 1)
      return { versions }
    }),
}))

export function selectReceiptVersion(roomId: string) {
  return (s: ReceiptState) => s.versions.get(roomId) ?? 0
}
